var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscoverExisting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "232 -824 496 688",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440.62-331.08q15.8 0 30.05-5.04 14.25-5.03 28.02-13.57l98.77 97.77 22.31-22.31L522-373q10.08-13 14.35-27.31 4.27-14.3 4.27-29.77 0-42.81-28.35-72.4-28.35-29.6-71.65-29.6-43.31 0-71.66 29.47-28.34 29.46-28.34 72.15t29.01 71.04q29.01 28.34 70.99 28.34m0-32q-27.7 0-47.85-19.86t-20.15-47.14q0-28.11 20.15-48.55 20.15-20.45 47.85-20.45 27.69 0 47.84 20.45 20.16 20.44 20.16 48.55 0 27.28-20.16 47.14-20.15 19.86-47.84 19.86M288.33-136Q264-136 248-152.15t-16-40.47v-574.76q0-24.32 16.15-40.47T288.62-824H596l132 132v499.38q0 24.32-16.16 40.47T671.34-136zM568-664v-128H288.62q-9.24 0-16.93 7.69T264-767.38v574.76q0 9.24 7.69 16.93t16.93 7.69h382.76q9.24 0 16.93-7.69t7.69-16.93V-664zM264-792v149zv624z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverExisting);
export default __webpack_public_path__ + "static/media/discover_existing.afcb807d96ae816f1fc6c63a3e10847d.svg";
export { ForwardRef as ReactComponent };